import React from "react";

import { useIntl, FormattedMessage } from "react-intl";

import * as S from "./DeleteActiveEnv.style";

export const DeleteActiveEnv = () => {
  const intl = useIntl();
  return (
    <S.StatusWrapper>
      <S.Title>
        {intl.formatMessage({
          id: "status_active_delete.title"
        })}
      </S.Title>
      <S.StatusSettingBodyText>
        <FormattedMessage id="status_active_delete.description" />
      </S.StatusSettingBodyText>
      <S.DeleteButton disabled analyticId="delete_environment">
        {intl.formatMessage({
          id: "delete_environment"
        })}
      </S.DeleteButton>
    </S.StatusWrapper>
  );
};
